// removed by extract-text-webpack-plugin
module.exports = {"card":"_3BieCtki0du9GdS_fu5dvW borderRadius-l borderStyle-solid borderWidth-1 position-relative","default":"_3PUTbA1dwe8F0tJQKTpyS- bg-white borderColor-smoke boxShadow-raise","blue":"AW-nLizOWaKnc6KcQd0WY bg-blue backgroundSize-cover borderColor-blue","enterprise":"_3S_Nf3x1zXEUQMt43OzTLZ bg-black backgroundSize-cover borderColor-black","isCurrent":"_3AQV9Qf8oUf65ifooummRQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Pricing/PlanBox/PlanBox.css
// module id = 767
// module chunks = 18116671869107 156544657062075